<template>
    <!-- Ionic modal provides --max-height -->
    <div
        class="pt-6 h-(--max-height) flex flex-col"
        data-cy="notifications-disabled-modal"
    >
        <ModalHeader @close="onCancelled">
            Update your preferences
        </ModalHeader>
        <IonContent
            ref="contentScroll"
            class="flex-1"
        >
            <div class="px-4 pb-(--beyond-safe-area-inset-bottom)">
                <DAlert>
                    <template #title>
                        Enable notifications
                    </template>
                    Notifications for {{ appName }} are turned off in your device's settings. Please enable them to manage your notification preferences within the app.
                </DAlert>
            </div>
        </IonContent>
    </div>
</template>
<script setup>
    import { DAlert } from '@digistorm/spark'

    const props = defineProps({
        onCancelled: Function,
    })

    const appStore = useAppStore()
    const appName = ref('this app')

    onMounted(async () => {
        appName.value = await appStore.getIconName()
    })
</script>
